import { Injectable } from '@angular/core';
import { RestService } from '../../../core/service/rest.service';
import { HomeAPIServiceConstant } from '../constant/home.constant';
@Injectable({
  providedIn: 'root'
})
export class HomeApiService {

  constructor(private rest: RestService) { }

  getDropDownPlantsAndWarehouse(parms: any) {
    return this.rest.get(HomeAPIServiceConstant.GET_DROPDOWN_PLANTS_AND_WAREHOUSE, parms);
  }
  getMaterialDetails(body: any) {
    return this.rest.post(HomeAPIServiceConstant.GET_MATERIAL_DETAILS, body);
  }
}
